module.exports = __webpack_public_path__ + "static/media/profile_1.078af909.jpg";